export type ArrayChunk = {
  indexFrom: number;
  indexTo: number;
  count: number;
};

export class ArrayUtils {
  /**
   * For the given enum, return all its values (correctly typed)
   * as an array so we can iterate over them.
   */
  public static enumToArray<T extends object>(enumValues: T): Array<T[keyof T]> {
    const keys = Object.keys(enumValues).filter(key => !/^[0-9]+$/.test(key)) as Array<keyof T>;
    return keys.map(key => enumValues[key]);
  }
}
